import React, { useState, useEffect } from 'react';
import './MenuItemModal.css';

const MenuItemModal = ({ item, isOpen, onClose, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);

  // Reset quantity when modal opens with a new item
  useEffect(() => {
    if (isOpen) {
      setQuantity(1);
    }
  }, [isOpen, item]);

  if (!isOpen || !item) return null;

  const handleAddToCart = () => {
    onAddToCart(item, quantity);
    // Brief delay before closing
    setTimeout(() => {
      onClose();
    }, 500);
  };

  const incrementQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decrementQuantity = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const handleOverlayClick = (e) => {
    // Close modal if clicking on the overlay (not the content)
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="menu-item-modal-overlay" onClick={handleOverlayClick}>
      <div className="menu-item-modal-content">
        <button className="modal-close-btn" onClick={onClose}>
          ×
        </button>

        <div className="modal-image-container">
          <img src={item.image} alt={item.name} className="modal-item-image" />
        </div>

        <div className="modal-item-details">
          <h2 className="modal-item-name">{item.name}</h2>

          {item.description && (
            <p className="modal-item-description">{item.description}</p>
          )}

          <div className="modal-item-price">
            ${item.price.toFixed(2)}
          </div>

          <div className="modal-quantity-selector">
            <label>Quantity:</label>
            <div className="quantity-controls">
              <button
                className="quantity-btn"
                onClick={decrementQuantity}
                disabled={quantity <= 1}
              >
                −
              </button>
              <span className="quantity-display">{quantity}</span>
              <button
                className="quantity-btn"
                onClick={incrementQuantity}
              >
                +
              </button>
            </div>
          </div>

          <button className="modal-add-to-cart-btn" onClick={handleAddToCart}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuItemModal;
